import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from "@angular/core";
import {MetricsService} from "../../services/metrics/metrics.service";

@Component({
  selector: 'cc-exchange-buttons',
  templateUrl: './chart-exchange-buttons-component.html',
  styleUrls: ['./chart-exchange-buttons-component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChartExchangeButtonsComponent {

  @Input()
  selectedExchangeCode: string;
  @Output()
  selectedExchangeChange = new EventEmitter<string>();
  @Input()
  exchangeCodes: string[];

  constructor(cdref: ChangeDetectorRef,
              private metricsService: MetricsService) {
  }


  selectExchange(exchangeCode) {
    this.selectedExchangeCode = exchangeCode;
    this.selectedExchangeChange.emit(this.selectedExchangeCode);
  }
}

